

import { get, deleteFetch, patch, post } from './commonFetch';

import type {
  MessageConfigurationResponse,
  PatchMessageConfigurationValuesRequest,
} from '../types/messageConfiguration';
import type { StatusResponse } from '../types/statusResponse';

export const getMessageConfigurations = (): Promise<MessageConfigurationResponse> => {
  return get('/api/messageConfigs').then(response => response as MessageConfigurationResponse);
};

export const createMessageConfig = (
  messageConfigId: string,
  name: string,
  isClone: boolean,
): Promise<string> => {
  return post('/api/messageConfigs/create', { messageConfigId, name, isClone });
};

export const patchMessageConfiguration = (
  messageConfigId: string,
  patchRequest: PatchMessageConfigurationValuesRequest,
): Promise<StatusResponse> => {
  return patch(`/api/messageConfigs/${messageConfigId}`, patchRequest);
};

export const deleteMessageConfig = (
  messageConfigId: string,
): Promise<StatusResponse> => {
  return deleteFetch(`/api/messageConfigs/${messageConfigId}`, {});
};
